import React from 'react';
import styled from 'styled-components';
import AdStatusBoard from 'Components/AdStatusBoard';
import { SuperAdminLayout } from 'Components/Layout/SuperAdminLayout';
import { useParams } from 'react-router-dom';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;

const SuperAdminAdStatusPage = () => {
  const { adId } = useParams<{ adId: string }>();
  return (
    <SuperAdminLayout>
      <ContentContainer>
        <AdStatusBoard adId={adId} />
      </ContentContainer>
    </SuperAdminLayout>
  );
};
export default SuperAdminAdStatusPage;
